import { type GuardStatus } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { ncwSendAssetAtom, ncwTransferAmountAtom } from '@capsicum/features/nc-wallet/shared';
import { useAtomValue } from 'jotai';

export const useNCWRecipientsFlowGuard = () => {
	const { push } = useRouter();
	const sendAsset = useAtomValue(ncwSendAssetAtom);
	const transferAmount = useAtomValue(ncwTransferAmountAtom);
	const status: GuardStatus = sendAsset === undefined || transferAmount === undefined ? 'denied' : 'allowed';

	return {
		onDenied: () => push('/nc-wallet'),
		status
	};
};
